import { Head } from "@inertiajs/react"

export default function UnsubscribeInvalid() {
  return (
    <>
      <Head title="Enlace inválido" />
      <div className="bg-background flex min-h-screen items-center justify-center p-4">
        <div className="bg-card w-full max-w-md rounded-xl p-8 shadow-md">
          <div className="mb-6 text-center">
            <span className="text-4xl">&#x274C;</span>
          </div>
          <h1 className="text-foreground mb-2 text-center text-xl font-bold">
            Enlace inválido
          </h1>
          <p className="text-center text-sm text-[#4a4a68]">
            Este enlace de desuscripción no es válido o ya expiró. Si necesitás
            ayuda, escribinos a{" "}
            <a href="mailto:info@currar.com" className="text-primary underline">
              info@currar.com
            </a>
          </p>
        </div>
      </div>
    </>
  )
}
